export default __webpack_public_path__ + "static/media/p23.4e560546.jpg";